import { connect } from "react-redux";
import { I18n, Translate } from "react-redux-i18n";
import React, { Component } from "react";

import AICommandBox from "../../js/ai/AICommandBox";
import BackButton from "../../components/menus/BackButton";
import EatWithMeText from "../../components/EatWIthMeText";
import FlexGrowSpace from "../../widgets/FlexGrowSpace";
import RestaurantSelector from "../../components/RestaurantSelector";
import TableReservationComponent from "./TableReservationComponent";
import SubmenuHeader from "../../components/menus/SubMenuHeader";

class TableReservations extends Component {
  state = {};
  render() {
    return this.props.myStatus.restaurant_id ? (
      <div id="bookTable" style={{ display: "flex", flexFlow: "column", flexGrow: 1, flexShrink: 1, overflow: "hidden", height: "100%" }}>
        <SubmenuHeader {...this.props} header={I18n.t("admin_local.menus.tableBooking")} />
        <TableReservationComponent />
        <AICommandBox />
      </div>
    ) : (
      ""
    );
  }
}

const mapStateToProps = (props, state) => {
  if (props.rootReducer.myStatus) {
    return {
      restaurant: props.rootReducer.restaurant,
      myStatus: props.rootReducer.myStatus,
      admin_local: props.rootReducer.admin_local,
      local: props.rootReducer.local,
      speechRecognitionOn: props.rootReducer.speechRecognitionOn,
      ai: props.rootReducer.ai,
      speechRecognitionAvailable: props.rootReducer.speechRecognitionAvailable
    };
  }
  return {};
};

export default connect(mapStateToProps)(TableReservations);
